// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconUserRight = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.4 6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0z',
      fill: '#fff'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.4 21.6V18A3.6 3.6 0 0 1 6 14.4h6m7.029-.9 2.57 2.4m0 0-2.57 2.4m2.57-2.4H15M14.4 6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0z',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconUserRight };
